import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Loader from '@app/components/ui/placeholders/Loader'
import { h } from '@app/helpers/translationHelper'
import _ from 'lodash'
import classnames from 'classnames'
import SVG from 'react-inlinesvg'
import placeholder from '@src/images/backgrounds/rewards-placeholder'
import download from '@icons/download/red'
import downloadWhite from '@icons/download/white'

class DiplomasTable extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { diplomas, applicableFor, downloadArchiveLink } = this.props

    if (!diplomas || diplomas.fetching) { return <Loader /> }

    if (!diplomas.object.length) {
      return (
        <Fragment>
          <p className="text-center black xl pt-1"
             dangerouslySetInnerHTML={ h('awards.placeholder_html') } />

          <SVG src={placeholder} className="text-center mt-4" />
        </Fragment>
      )
    }

    return (
      <table className="diplomas-table">
        <tbody>
          { _.map(diplomas.object, (result, index) => {
              return (
                <tr key={result.student.id}>
                  <td>
                    { index + 1 }.
                  </td>
                  <td>
                    { result.student.fullName }
                  </td>
                  <td>
                    <a href={result.participation.download}
                       target="_blank"
                       className="link link--icon-left link--text-gray h-100">

                      <SVG src={download} />
                      { I18n.t('awards.download') }
                    </a>
                  </td>
                </tr>
              )
            })
          }
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="3">
              <a href={downloadArchiveLink}
                 target="_blank"
                 className="btn btn--icon-right btn--red btn--md mt-4">

                { I18n.t('awards.download_all') }
                <SVG src={downloadWhite} />
              </a>

              <p className="text-center paragraph black my-1"
                 dangerouslySetInnerHTML={
                   applicableFor === 'teacher' ?
                     h('awards.download_archive_teacher_html') :
                     h('awards.download_archive_parent_html')
                 }
              />
            </td>
          </tr>
        </tfoot>
      </table>
    )
  }
}

DiplomasTable.propTypes = {
  applicableFor: PropTypes.oneOf(['parent', 'teacher']).isRequired,
  downloadArchiveLink: PropTypes.string.isRequired
}

export default DiplomasTable
